












import mixins from 'vue-typed-mixins'
import layoutMixin from './layout/layoutMixin'

export default mixins(layoutMixin).extend({
    components: {
        Navbar: () => import('./layout/components/Navbar.vue'),
        Footer: () => import('./layout/components/Footer.vue'),
        Loading: () => import('./layout/components/Loading.vue'),
    },
    mounted() {
        this.initialize()
    },
})
